import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Input, FormGroup, Label, Row, Col } from 'reactstrap';
import Icon from '@ailibs/feather-react-ts';
import { IPopUp } from '../iPopUp/IpopUp';
import { ITable } from '../iTable/ITable';
import './iSelector.scss';

import { IInput } from '../iInput/iInput';
import IButtonComponent from '../iButton/IButton';

export const ISelector = ({
  nameSelector,
  value,
  title,
  dataSelector,
  CountItems,
  remote = false,
  valuesSizePagination,
  initialArrayTable,
  handlePaginationChange,
  setSelectedRow,
  onChangeHandler,
  style = {},
  titleSearch = undefined,
  getQuery,
  getModalStatus,
  queryRemote = false,
  isLoading = false,
  formControl = false,
  onClickButton = {label: "",actionOnClick: ()=>{},showButton:false}
}: any) => {
  const [popUpState, setpopUpState] = useState(false);
  const [updateState, setUpdateState] = useState(false);
  const [query, setQuery] = useState('');
  const [data, setData] = useState(dataSelector);

  const miInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setData(dataSelector);
  }, [dataSelector]);

  useEffect(() => {
    if (getModalStatus) getModalStatus(popUpState);
  }, [popUpState]);

  useEffect(() => {
    if (!queryRemote) {
      const value = query.toLowerCase();
      let res;
      if (value.length < 3) {
        res = dataSelector;
      } else {
        res = dataSelector?.filter((item: any) => {
          const key = item.nombre ?? item.name ?? item.descripcion;
          return key.toLowerCase().includes(value);
        });
      }
      setData(res);
    } else {
      if (getQuery) getQuery(query);
    }
  }, [query]);

  const onPopUpState = () => {
    setpopUpState(!popUpState);
  };

  const handleActionOnRowClick = (row: any) => {
    setpopUpState(!popUpState);
    setSelectedRow(title, row);
    setQuery('');
  };

  const handleClick = () => {
    miInput.current?.focus();
  };
  const onChangeQueryHandler = (e: any) => {
    setQuery(e.target.value);
  };

  return (
    <>
      <FormGroup
        style={style}
        onClick={handleClick}
        className={`${formControl ? "custom-form-group":"formGroupStyle"} cursor-text position-relative`}
      >
        {!formControl ? (
          <Label className="text-capitalize text-label ps-3">
          {title.replace(/_/g, ' ').toLowerCase()}
        </Label>
        ):null}

        <Row className={`me-1 ms-1 text-center ${formControl ? "h-full":""}`}>
          <Col sm={2} onClick={handleClick}>
            <input
              className="row-height"
              ref={miInput}
              value={value}
              type="number"
              onChange={(e: any) => onChangeHandler(e, title)}
            />
          </Col>
          <Col sm={7}>
            <Input
              onClick={handleClick}
              className="row-height text-center cursor-text"
              value={nameSelector}
            />
          </Col>
        </Row>
        <Icon
          name="more-vertical"
          size={formControl ? 20:30}
          color="gray"
          className="cursor-pointer icon-position position-absolute"
          onClick={() => setpopUpState(true)}
        />
      </FormGroup>

      <IPopUp
        stateAdd={popUpState}
        switchStateAdd={setpopUpState}
        stateUpdate={updateState}
        switchStateUpdate={setUpdateState}
        modalTitleAdd={'SEARCH ' + title.replace(/_/g, ' ')}
        icon="search"
        colorHeaderPop={'#101340'}
      >
        <div className="tableStyle">
          <div className="d-flex justify-content-center align-items-center  pt-2">
            <Col sm={6}>
              <IInput
                title={'Search ' + (titleSearch ?? title)}
                value={query}
                type={'text'}
                onChangeHandler={onChangeQueryHandler}
              />
            </Col>

            {onClickButton  && onClickButton.showButton ?  (
              <IButtonComponent
              type="button"
              className="btn-search text-nowrap w-auto"
              actionOnClick={()=>onClickButton.actionOnClick(query,onPopUpState)}
              label={`${onClickButton.label}`}
              btnIcon="dripicons-folder-open"
              disabled={false}
          ></IButtonComponent>
            ):null}

          </div>

          <ITable
            remote={remote}
            CountItems={CountItems}
            valuesSizePagination={valuesSizePagination}
            isLoading={isLoading}
            enableDownload={false}
            data={data}
            fields={initialArrayTable}
            tableColumns={initialArrayTable}
            showTotal={true}
            disablePageTitle={true}
            headerColorT={'bg-primary text-white'}
            groupName=""
            handlePopUpState={onPopUpState}
            actionOnRowClick={handleActionOnRowClick}
            handlerPaginationState={handlePaginationChange}
          />
        </div>
      </IPopUp>
    </>
  );
};

ISelector.propTypes = {
  nameSelector: PropTypes.string,
  value: PropTypes.string,
  title: PropTypes.string,
  titleSearch: PropTypes.string,
  CountItems: PropTypes.string,
  remote: PropTypes.bool,
  dataSelector: PropTypes.array,
  initialArrayTable: PropTypes.array,
  valuesSizePagination: PropTypes.array,
  handlePaginationChange: PropTypes.func,
  setSelectedRow: PropTypes.func,
  onChangeHandler: PropTypes.func,
  style: PropTypes.object,
  queryRemote: PropTypes.bool,
  getQuery: PropTypes.func,
  getModalStatus: PropTypes.func,
  isLoading: PropTypes.bool,
  formControl: PropTypes.bool,
  onClickButton: PropTypes.any
};
